/**
 * After a deploy, a tab still running the previous build asks for script and CSS files the new
 * release no longer has (Firebase serves only the current release, and the SPA fallback answers
 * them with index.html). The screen being opened then never loads: Loadable shows its `loading`
 * (an empty span almost everywhere) until the user refreshes.
 *
 * Vite reports every failed lazy load as `vite:preloadError` (build only; dev never fires it).
 * The tab reloads once to pick up the new build. The guard is this build's entry file: if the
 * same build fails again after its reload, that's a real error and is left to the normal error
 * path (no reload loop). Offline, nothing reloads; the browser's offline page helps no one.
 */
const RELOADED_KEY = "mx-stale-build-reload"

function currentBuild() {
    return document.querySelector('script[type="module"][src*="/assets/"]')?.src || ""
}

window.addEventListener("vite:preloadError", (event) => {
    if (!navigator.onLine) return

    const build = currentBuild()
    try {
        if (sessionStorage.getItem(RELOADED_KEY) === build) return
        sessionStorage.setItem(RELOADED_KEY, build)
    } catch {
        return
    }

    event.preventDefault()
    window.location.reload()
})
